// extracted by mini-css-extract-plugin
export default {"name":"Name_name__peVeS","design":"Name_design__g0Ngm","avatar":"Name_avatar__Cg5uW","resumeButton":"Name_resumeButton__C4dBm","resume":"Name_resume__Hj3B+"};